export default class Sidebar{

};